<template>
  <validation-observer
    v-slot="propertyAlarmInstalledObserver"
    slim
  >
    <form-section
      id="property-alarm-installed"
      v-bind="propertyAlarmInstalledObserver"
      :validated="formObserver.validated"
    >
      <form-row
        label="Does the property have an alarm system installed?"
      >
        <validation-provider
          v-slot="{ failed }"
          name="Property Alarm Installed"
          :vid="`${stepId}_property-alarm-installed`"
          rules="required"
          slim
        >
          <radio
            v-model="questionData.propertyAlarmInstalled"
            name="is-property-alarm-installed"
            wide
            :error="failed"
            :items="constants.YES_NO"
            :data-test="snakeCase(questionFields.propertyAlarmInstalled)"
          />
        </validation-provider>
      </form-row>

      <template v-if="questionData.propertyAlarmInstalled">
        <!--  PROPERTY PROF ALARM  -->
        <form-row
          id="property-prof-alarm"
          question="Has the alarm been fitted and maintained annually by a NACOSS, NSI or SSAIB approved company?"
        >
          <validation-provider
            v-slot="{ failed }"
            name="Property Prof Alarm"
            :vid="`${stepId}_property-prof-alarm`"
            rules="required"
            slim
          >
            <radio
              v-model="questionData.propertyProfAlarm"
              name="is-property-prof-alarm"
              wide
              :error="failed"
              :items="constants.YES_NO"
              :data-test="snakeCase(questionFields.propertyProfAlarm)"
            />
          </validation-provider>

          <template #helpText>
            <p>Check with the company that installed and services your alarm if they are NACOSS, NSI or SSAIB approved.</p>
          </template>
        </form-row>
        <!--  PROPERTY ALERT ALARM  -->
        <form-row
          id="property-alert-alarm"
          question="Is the alarm monitored?"
        >
          <validation-provider
            v-slot="{ failed }"
            name="Property Alert Alarm"
            :vid="`${stepId}_property-alert-alarm`"
            rules="required"
            slim
          >
            <radio
              v-model="questionData.propertyAlertAlarm"
              name="is-property-alert-alarm"
              wide
              :error="failed"
              :items="constants.YES_NO"
              :data-test="snakeCase(questionFields.propertyAlertAlarm)"
            />
          </validation-provider>

          <template #helpText>
            <p>A monitored alarm connects to an external security company, which monitors signals from your alarm.</p>
          </template>
        </form-row>
      </template>
    </form-section>
  </validation-observer>
</template>

<script>
import QuestionBase from '@/components/questions/Base.vue';

export default {
  name: 'question-property-alarm-installed',
  extends: QuestionBase,
  data () {
    return {
      fields: ['propertyAlarmInstalled', 'propertyProfAlarm', 'propertyAlertAlarm'],
    };
  },
  watch: {
    'questionData.propertyAlarmInstalled' (isInstalled) {
      if (!isInstalled) {
        this.questionData.propertyProfAlarm = false;
        this.questionData.propertyAlertAlarm = false;
      }
    },
  },
};
</script>
